// CONVERT_TO_WIN_REQUEST

import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import { CONVERT_TO_WIN_FAILURE, CONVERT_TO_WIN_REQUEST, CONVERT_TO_WIN_SUCCESS } from "../../actions/opportunities/convertToWinAction";

  const initialState = {
    convertToWinLoading: true,
    convertToWinData: [],
    convertToWinError: null,
  };
  
  const convertToWinReducer = (state = initialState, action) => {
    switch (action.type) {
      case CONVERT_TO_WIN_REQUEST:
        return { ...state, convertToWinLoading: true , payload: action.payload};
      case CONVERT_TO_WIN_SUCCESS:
        return { ...state, convertToWinLoading: false, convertToWinData: action.payload };
      case CONVERT_TO_WIN_FAILURE:
        return { ...state, convertToWinLoading: false, convertToWinError: action.payload };      
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
              return initialState      
      default:
        return state;
    }
  };
  
  export default convertToWinReducer;
  